import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1';
let preferencesCache = null;

class ClientService {
  static async getClientInfo() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/gerenciamentoDeClientes/pesquisarCliente`,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async getAuthUrl() {
    const response = await api.get(
      `${BASE_PATH}/gateways/pagbank/authorize`,
      { params: { state: 'FoodzApp' } }
    );
    return response.data;
  }

  static async handleCallback(code) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/gateways/pagbank/callback`,
      { params: { code, clientCode, state: 'FoodzAppTest' } }
    );
    return response.data;
  }

  static async checkIfPagbankIsConnected() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/gateways/pagbank/pagbankcheck`,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async saveSmtpConnection(token) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.post(
      `${BASE_PATH}/integrations/smtp`,
      token,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async checkIfSmtpIsConnected() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/integrations/smtpcheck`,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async getClientAdminPreferences() {
    if (preferencesCache) {
      return preferencesCache;
    }

    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/preferenciasAdmin`,
      { params: { clientCode } }
    );
    preferencesCache = response.data;
    return preferencesCache;
  }

  static async updateClientAdminPreferences(preferences) {
    const clientCode = sessionStorage.getItem('clientCode');
    preferencesCache = null;
    const response = await api.put(
      `${BASE_PATH}/preferenciasAdmin`,
      preferences,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async checkAdminOperationalPin(pin) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/preferenciasAdmin/checar-pin`,
      { params: { clientCode, pin } }
    );
    return response.data;
  }

  static async checkPermissions() {
    const response = await api.get(
      `${BASE_PATH}/preferenciasAdmin/permissoes`
    );
    return response.data;
  }

  static async updateUserPermissions(id, permissionIds) {
    const response = await api.put(
      `${BASE_PATH}/preferenciasAdmin/${id}/atualizar-permissoes`,
      { permissionIds }
    );
    return response.data;
  }

  static async getTurns() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/preferenciasAdmin/turnos`,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async updateTurns(turns) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.put(
      `${BASE_PATH}/preferenciasAdmin/turnos`,
      turns,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async countActiveStudentsForTurn(turnId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/preferenciasAdmin/turnos/${turnId}/alunos-ativos`,
      { params: { clientCode } }
    );
    return response.data;
  }

  clearCache() {
    preferencesCache = null;
  }

  static async getAsaasStatus() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/integrations/asaas/status`,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async asaasOnboard(body) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.post(
      `${BASE_PATH}/integrations/asaas/onboard`,
      body,
      { params: { clientCode } }
    );
    return response.data;
  }
}

export default ClientService;
